import { render, staticRenderFns } from "./StatsButtonTabs.vue?vue&type=template&id=3bbe5ef4"
import script from "./StatsButtonTabs.vue?vue&type=script&lang=js"
export * from "./StatsButtonTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports